import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../components/PrivacyPolicy.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../components/TermsOfService.vue')
    }
  ]
})

export default router
